import {
  FITTING_TYPE_PAGE_PATTERN,
  PIERCING_TYPE_PAGE_PATTERN,
  EDIT_ADDRESS_PAGE_PATTERN,
  SHOPS_PAGE_PATTERN,
  SELECT_TREATMENT_PAGE_PATTERN,
  PARTNERS_PAGE_PATTERN,
  SELECT_DATE_PAGE_PATTERN,
  ABOUT_YOU_PAGE_PATTERN,
  REVIEW_PAGE_PATTERN,
  COMPLETE_PAGE_PATTERN,
  EDIT_SHOP_PAGE_PATTERN,
  EDIT_PARTNERS_PAGE_PATTERN,
  EDIT_DATE_PAGE_PATTERN,
  PRODUCTS_PAGE_PATTERN,
  SELECT_TREATMENTS_PAGE_STEP_LABEL,
  GUIDE_PAGE_STEP_LABEL,
  FITTING_TYPE_PAGE_STEP_LABEL,
  PIERCING_TYPE_PAGE_STEP_LABEL,
  ADDRESS_PAGE_STEP_LABEL,
  MEASURING_ADDRESS_LABEL,
  SHOPS_PAGE_STEP_LABEL,
  PROPERTY_ADDRESS_STEP_LABEL,
  PARTNERS_PAGE_STEP_LABEL,
  SELECT_DATE_PAGE_STEP_LABEL,
  ABOUT_YOU_PAGE_STEP_LABEL,
  REVIEW_PAGE_STEP_LABEL,
  COMPLETE_PAGE_STEP_LABEL,
  PRODUCTS_PAGE_STEP_LABEL,
  WELDING_TYPE_PAGE_STEP_LABEL,
  WELDING_TYPE_PAGE_PATTERN,
} from './progress-bar.constants';

export { ProgressBar, ConnectedProgressBar } from './ProgressBar';

const progressBarConstants = {
  patterns: {
    SELECT_TREATMENT_PAGE_PATTERN,
    FITTING_TYPE_PAGE_PATTERN,
    PIERCING_TYPE_PAGE_PATTERN,
    EDIT_ADDRESS_PAGE_PATTERN,
    SHOPS_PAGE_PATTERN,
    PARTNERS_PAGE_PATTERN,
    PRODUCTS_PAGE_PATTERN,
    SELECT_DATE_PAGE_PATTERN,
    ABOUT_YOU_PAGE_PATTERN,
    REVIEW_PAGE_PATTERN,
    COMPLETE_PAGE_PATTERN,
    EDIT_SHOP_PAGE_PATTERN,
    EDIT_PARTNERS_PAGE_PATTERN,
    EDIT_DATE_PAGE_PATTERN,
    WELDING_TYPE_PAGE_PATTERN,
  },
  labels: {
    SELECT_TREATMENTS_PAGE_STEP_LABEL,
    GUIDE_PAGE_STEP_LABEL,
    FITTING_TYPE_PAGE_STEP_LABEL,
    PIERCING_TYPE_PAGE_STEP_LABEL,
    ADDRESS_PAGE_STEP_LABEL,
    MEASURING_ADDRESS_LABEL,
    SHOPS_PAGE_STEP_LABEL,
    PROPERTY_ADDRESS_STEP_LABEL,
    PARTNERS_PAGE_STEP_LABEL,
    SELECT_DATE_PAGE_STEP_LABEL,
    ABOUT_YOU_PAGE_STEP_LABEL,
    REVIEW_PAGE_STEP_LABEL,
    COMPLETE_PAGE_STEP_LABEL,
    PRODUCTS_PAGE_STEP_LABEL,
    WELDING_TYPE_PAGE_STEP_LABEL,
  },
};

export { progressBarConstants };
